module.exports = __webpack_public_path__ + "img/ingredienten-burgers-met-italiaanse-kruiden.1484c8b1.jpeg";